var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, artworkSize, artworks, displayPrice, displayPurchase, hasAuctionPartner, hasInstitutionPartner, image, imageHeight, imageSizes, imageWidth, isAuction, seeMore, set, showBlurbs, showBuyButton, showBuyLink, showContact, undefined) {
buf.push("<ul class=\"fillwidth-list\">");
// iterate artworks
;(function(){
  var $$obj = artworks;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

buf.push("<li class=\"fillwidth-row\">");
artworkSize = artworkSize || 'medium'
imageWidth = imageWidth || false
imageHeight = imageHeight || false
displayPurchase = displayPurchase || false
showBlurbs = showBlurbs || false
isAuction = isAuction || (set && set.get('type') === 'auction artworks') || false
hasInstitutionPartner = artwork.get('partner') && artwork.get('partner').type === 'Institution' && !artwork.get('forsale')
displayPrice != null ? displayPrice : displayPrice = true
saleArtwork = artwork.related().saleArtwork
hasAuctionPartner = (artwork.get('partner') && (artwork.get('partner').type === 'Auction' || artwork.get('partner').type === 'Auction House')) || artwork.get('is_biddable')
showContact = !isAuction && artwork.isContactable()
showBuyButton = displayPurchase && artwork.get('acquireable')
showBuyLink = artwork.get('acquireable') && artwork.get('ecommerce') && !showBuyButton
buf.push("<figure" + (jade.attr("data-artwork", artwork.get('id'), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"artwork-item-image-link\">");
if ( imageWidth)
{
var defaultImage = artwork.defaultImage()
var maxDimension = maxDimension || imageWidth * 2
buf.push("<img" + (jade.attr("src", defaultImage.imageUrlForWidth(imageWidth), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + (jade.attr("width", defaultImage.maxWidthForWidth(imageWidth, maxDimension), true, true)) + (jade.attr("height", defaultImage.maxHeightForWidth(imageWidth, maxDimension), true, true)) + " class=\"artwork-item-image\">");
}
else if ( imageHeight)
{
var defaultImage = artwork.defaultImage()
var maxDimension = maxDimension || imageHeight * 2
buf.push("<img" + (jade.attr("src", defaultImage.imageUrlForHeight(imageHeight), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + (jade.attr("height", defaultImage.maxHeightForHeight(imageHeight, maxDimension), true, true)) + " class=\"artwork-item-image\">");
}
else
{
image = artwork.defaultImage()
imageSizes = (artworkSize instanceof Array ? artworkSize : [artworkSize]).concat(['tall', 'large', 'larger', 'medium', 'small'])
if ( !image.isCropped(artworkSize) && image.hasDimensions())
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (image.factor() * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", image.bestImageUrl(imageSizes), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + "></div>");
}
else
{
buf.push("<img" + (jade.attr("src", image.bestImageUrl(imageSizes), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + " class=\"artwork-item-image\">");
}
}
if ( artwork.collection && artwork.collection.artworkCollection)
{
buf.push("<div" + (jade.attr("data-id", artwork.get('id'), true, true)) + (jade.attr("data-collection-id", artwork.collection.artworkCollection.id, true, true)) + " class=\"artwork-item-remove icon-remove-small\"></div>");
}
buf.push("<div class=\"overlay-container\"><div data-test=\"saveArtwork\" class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.related().artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.related().artists.models
;(function(){
  var $$obj = artwork.related().artists.models;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.get('public'))
{
buf.push("<a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.get('public'))
{
buf.push("<a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\">");
if ( isAuction && artwork.related().saleArtwork && artwork.related().saleArtwork.get('lot_label'))
{
buf.push("<div class=\"artwork-item-lot-number\">Lot " + (jade.escape((jade_interp = artwork.related().saleArtwork.get('lot_label')) == null ? '' : jade_interp)) + "</div>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = artwork.titleAndYear()) ? "" : jade_interp) + "</p></a>");
if ( artwork.partnerName())
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partnerLink())
{
buf.push("<a" + (jade.attr("href", artwork.partnerLink(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( !hasInstitutionPartner && !hasAuctionPartner && !isAuction)
{
if ( artwork.saleMessage() && displayPrice)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\"><p class=\"artwork-item-sale-price artwork-item-overflow\">" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</p></a>");
}
else if ( artwork.availabilityMessage())
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\"><p class=\"artwork-item-availability\">" + (jade.escape(null == (jade_interp = artwork.availabilityMessage()) ? "" : jade_interp)) + "</p></a>");
}
}
if ( saleArtwork.id && isAuction)
{
if ( saleArtwork.estimate())
{
buf.push("<p class=\"artwork-item-estimate\">" + (jade.escape((jade_interp = saleArtwork.estimateLabel()) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = saleArtwork.estimate()) == null ? '' : jade_interp)) + "</p>");
}
}
var displayBidStatus = saleArtwork.id && isAuction
var displayBuyNowPrice = artwork.saleMessage() && displayPrice && isAuction
if ( displayBuyNowPrice || displayBidStatus)
{
buf.push("<div class=\"artwork-item-sale-metadata\">");
if ( artwork.get('sold'))
{
buf.push("<div class=\"artwork-item-buy-now-price\">" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</div>");
}
else
{
if ( displayBidStatus)
{
var saleArtwork = artwork.related().saleArtwork
buf.push("<div class=\"artwork-item-auction-bid-status\">" + (jade.escape((jade_interp = saleArtwork.bidLabel()) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = saleArtwork.currentBid()) == null ? '' : jade_interp)) + "");
if ( saleArtwork.get('bidder_positions_count') >= 1)
{
buf.push("&nbsp;" + (jade.escape((jade_interp = saleArtwork.formatBidCount()) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( displayBuyNowPrice)
{
buf.push("<div class=\"artwork-item-buy-now-price\">Buy now price: " + (jade.escape((jade_interp = artwork.saleMessage()) == null ? '' : jade_interp)) + "</div>");
}
}
buf.push("</div>");
}
if ( saleArtwork.id || showBlurbs)
{
var saleArtwork = artwork.related().saleArtwork
if ( artwork.has('blurb') && artwork.get('blurb'))
{
buf.push("<div class=\"artwork-item-blurb\">" + (null == (jade_interp = artwork.mdToHtml('blurb')) ? "" : jade_interp) + "</div>");
}
else
{
if ( saleArtwork && saleArtwork.get('user_notes'))
{
buf.push("<div class=\"artwork-item-blurb\">" + (null == (jade_interp = saleArtwork.mdToHtml('user_notes')) ? "" : jade_interp) + "</div>");
}
}
}
if ( saleArtwork.id || showBlurbs)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item-more-info avant-garde-button-black is-tiny\">More Info</a>");
}
if ( isAuction && !artwork.get('sold'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item-bid avant-garde-button-black is-tiny\">Bid</a>");
if ( artwork.get('acquireable'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy-now avant-garde-button-black is-tiny\">Buy now</a>");
}
}
if ( hasAuctionPartner && !isAuction)
{
buf.push("<div class=\"artwork-item-caption__bid-now\">");
if ( artwork.get('forsale') || artwork.get('is_for_sale'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + ">Bid now</a>");
}
else
{
buf.push("Auction closed");
}
buf.push("</div>");
}
if ( showBuyButton)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy avant-garde-button-black is-tiny\">Buy</a>");
}
else if ( showBuyLink)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy is-tiny\">Buy</a>");
}
else if ( showContact && !hasAuctionPartner)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-artwork_id", artwork.get('_id'), true, true)) + " data-context_type=\"artwork feed item\" class=\"artwork-item-contact-seller js-artwork-item-contact-seller analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.contactLabel()) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

buf.push("<li class=\"fillwidth-row\">");
artworkSize = artworkSize || 'medium'
imageWidth = imageWidth || false
imageHeight = imageHeight || false
displayPurchase = displayPurchase || false
showBlurbs = showBlurbs || false
isAuction = isAuction || (set && set.get('type') === 'auction artworks') || false
hasInstitutionPartner = artwork.get('partner') && artwork.get('partner').type === 'Institution' && !artwork.get('forsale')
displayPrice != null ? displayPrice : displayPrice = true
saleArtwork = artwork.related().saleArtwork
hasAuctionPartner = (artwork.get('partner') && (artwork.get('partner').type === 'Auction' || artwork.get('partner').type === 'Auction House')) || artwork.get('is_biddable')
showContact = !isAuction && artwork.isContactable()
showBuyButton = displayPurchase && artwork.get('acquireable')
showBuyLink = artwork.get('acquireable') && artwork.get('ecommerce') && !showBuyButton
buf.push("<figure" + (jade.attr("data-artwork", artwork.get('id'), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"artwork-item-image-link\">");
if ( imageWidth)
{
var defaultImage = artwork.defaultImage()
var maxDimension = maxDimension || imageWidth * 2
buf.push("<img" + (jade.attr("src", defaultImage.imageUrlForWidth(imageWidth), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + (jade.attr("width", defaultImage.maxWidthForWidth(imageWidth, maxDimension), true, true)) + (jade.attr("height", defaultImage.maxHeightForWidth(imageWidth, maxDimension), true, true)) + " class=\"artwork-item-image\">");
}
else if ( imageHeight)
{
var defaultImage = artwork.defaultImage()
var maxDimension = maxDimension || imageHeight * 2
buf.push("<img" + (jade.attr("src", defaultImage.imageUrlForHeight(imageHeight), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + (jade.attr("height", defaultImage.maxHeightForHeight(imageHeight, maxDimension), true, true)) + " class=\"artwork-item-image\">");
}
else
{
image = artwork.defaultImage()
imageSizes = (artworkSize instanceof Array ? artworkSize : [artworkSize]).concat(['tall', 'large', 'larger', 'medium', 'small'])
if ( !image.isCropped(artworkSize) && image.hasDimensions())
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (image.factor() * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", image.bestImageUrl(imageSizes), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + "></div>");
}
else
{
buf.push("<img" + (jade.attr("src", image.bestImageUrl(imageSizes), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + " class=\"artwork-item-image\">");
}
}
if ( artwork.collection && artwork.collection.artworkCollection)
{
buf.push("<div" + (jade.attr("data-id", artwork.get('id'), true, true)) + (jade.attr("data-collection-id", artwork.collection.artworkCollection.id, true, true)) + " class=\"artwork-item-remove icon-remove-small\"></div>");
}
buf.push("<div class=\"overlay-container\"><div data-test=\"saveArtwork\" class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.related().artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.related().artists.models
;(function(){
  var $$obj = artwork.related().artists.models;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.get('public'))
{
buf.push("<a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.get('public'))
{
buf.push("<a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\">");
if ( isAuction && artwork.related().saleArtwork && artwork.related().saleArtwork.get('lot_label'))
{
buf.push("<div class=\"artwork-item-lot-number\">Lot " + (jade.escape((jade_interp = artwork.related().saleArtwork.get('lot_label')) == null ? '' : jade_interp)) + "</div>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = artwork.titleAndYear()) ? "" : jade_interp) + "</p></a>");
if ( artwork.partnerName())
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partnerLink())
{
buf.push("<a" + (jade.attr("href", artwork.partnerLink(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( !hasInstitutionPartner && !hasAuctionPartner && !isAuction)
{
if ( artwork.saleMessage() && displayPrice)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\"><p class=\"artwork-item-sale-price artwork-item-overflow\">" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</p></a>");
}
else if ( artwork.availabilityMessage())
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\"><p class=\"artwork-item-availability\">" + (jade.escape(null == (jade_interp = artwork.availabilityMessage()) ? "" : jade_interp)) + "</p></a>");
}
}
if ( saleArtwork.id && isAuction)
{
if ( saleArtwork.estimate())
{
buf.push("<p class=\"artwork-item-estimate\">" + (jade.escape((jade_interp = saleArtwork.estimateLabel()) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = saleArtwork.estimate()) == null ? '' : jade_interp)) + "</p>");
}
}
var displayBidStatus = saleArtwork.id && isAuction
var displayBuyNowPrice = artwork.saleMessage() && displayPrice && isAuction
if ( displayBuyNowPrice || displayBidStatus)
{
buf.push("<div class=\"artwork-item-sale-metadata\">");
if ( artwork.get('sold'))
{
buf.push("<div class=\"artwork-item-buy-now-price\">" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</div>");
}
else
{
if ( displayBidStatus)
{
var saleArtwork = artwork.related().saleArtwork
buf.push("<div class=\"artwork-item-auction-bid-status\">" + (jade.escape((jade_interp = saleArtwork.bidLabel()) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = saleArtwork.currentBid()) == null ? '' : jade_interp)) + "");
if ( saleArtwork.get('bidder_positions_count') >= 1)
{
buf.push("&nbsp;" + (jade.escape((jade_interp = saleArtwork.formatBidCount()) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( displayBuyNowPrice)
{
buf.push("<div class=\"artwork-item-buy-now-price\">Buy now price: " + (jade.escape((jade_interp = artwork.saleMessage()) == null ? '' : jade_interp)) + "</div>");
}
}
buf.push("</div>");
}
if ( saleArtwork.id || showBlurbs)
{
var saleArtwork = artwork.related().saleArtwork
if ( artwork.has('blurb') && artwork.get('blurb'))
{
buf.push("<div class=\"artwork-item-blurb\">" + (null == (jade_interp = artwork.mdToHtml('blurb')) ? "" : jade_interp) + "</div>");
}
else
{
if ( saleArtwork && saleArtwork.get('user_notes'))
{
buf.push("<div class=\"artwork-item-blurb\">" + (null == (jade_interp = saleArtwork.mdToHtml('user_notes')) ? "" : jade_interp) + "</div>");
}
}
}
if ( saleArtwork.id || showBlurbs)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item-more-info avant-garde-button-black is-tiny\">More Info</a>");
}
if ( isAuction && !artwork.get('sold'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item-bid avant-garde-button-black is-tiny\">Bid</a>");
if ( artwork.get('acquireable'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy-now avant-garde-button-black is-tiny\">Buy now</a>");
}
}
if ( hasAuctionPartner && !isAuction)
{
buf.push("<div class=\"artwork-item-caption__bid-now\">");
if ( artwork.get('forsale') || artwork.get('is_for_sale'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + ">Bid now</a>");
}
else
{
buf.push("Auction closed");
}
buf.push("</div>");
}
if ( showBuyButton)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy avant-garde-button-black is-tiny\">Buy</a>");
}
else if ( showBuyLink)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy is-tiny\">Buy</a>");
}
else if ( showContact && !hasAuctionPartner)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-artwork_id", artwork.get('_id'), true, true)) + " data-context_type=\"artwork feed item\" class=\"artwork-item-contact-seller js-artwork-item-contact-seller analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.contactLabel()) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure></li>");
    }

  }
}).call(this);

buf.push("</ul>");
if ( seeMore)
{
buf.push("<button class=\"avant-garde-button-text fillwidth-see-more\">See More</button>");
}}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"artworkSize" in locals_for_with?locals_for_with.artworkSize:typeof artworkSize!=="undefined"?artworkSize:undefined,"artworks" in locals_for_with?locals_for_with.artworks:typeof artworks!=="undefined"?artworks:undefined,"displayPrice" in locals_for_with?locals_for_with.displayPrice:typeof displayPrice!=="undefined"?displayPrice:undefined,"displayPurchase" in locals_for_with?locals_for_with.displayPurchase:typeof displayPurchase!=="undefined"?displayPurchase:undefined,"hasAuctionPartner" in locals_for_with?locals_for_with.hasAuctionPartner:typeof hasAuctionPartner!=="undefined"?hasAuctionPartner:undefined,"hasInstitutionPartner" in locals_for_with?locals_for_with.hasInstitutionPartner:typeof hasInstitutionPartner!=="undefined"?hasInstitutionPartner:undefined,"image" in locals_for_with?locals_for_with.image:typeof image!=="undefined"?image:undefined,"imageHeight" in locals_for_with?locals_for_with.imageHeight:typeof imageHeight!=="undefined"?imageHeight:undefined,"imageSizes" in locals_for_with?locals_for_with.imageSizes:typeof imageSizes!=="undefined"?imageSizes:undefined,"imageWidth" in locals_for_with?locals_for_with.imageWidth:typeof imageWidth!=="undefined"?imageWidth:undefined,"isAuction" in locals_for_with?locals_for_with.isAuction:typeof isAuction!=="undefined"?isAuction:undefined,"seeMore" in locals_for_with?locals_for_with.seeMore:typeof seeMore!=="undefined"?seeMore:undefined,"set" in locals_for_with?locals_for_with.set:typeof set!=="undefined"?set:undefined,"showBlurbs" in locals_for_with?locals_for_with.showBlurbs:typeof showBlurbs!=="undefined"?showBlurbs:undefined,"showBuyButton" in locals_for_with?locals_for_with.showBuyButton:typeof showBuyButton!=="undefined"?showBuyButton:undefined,"showBuyLink" in locals_for_with?locals_for_with.showBuyLink:typeof showBuyLink!=="undefined"?showBuyLink:undefined,"showContact" in locals_for_with?locals_for_with.showContact:typeof showContact!=="undefined"?showContact:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;